import { BulkResizeImage } from "store/features/bulkResize/types";
import { Dimension } from "store/types/resizeSettings";
import { Unit } from "store/types/unit";
import { validateResizeDimension } from "client/utils/validateResizeDimension";

export const MAX_RESIZE_SIZE_IN_PX = 20000;
export const MAX_RESIZE_SIZE_FOR_WEBP_IN_PX = 16383;

export const validateResizeDimensions = (
    images: BulkResizeImage[],
    dimensionType: Dimension,
    unit: Unit,
    percentage: number = 100,
    saveAs: string,
    dpi?: number,
): boolean => {
    let isValid = true;

    images.forEach((image) => {
        const outputExt = saveAs === "original" ? image.format.replace(".", "") : saveAs.replace(".", "");
        const maxSize = outputExt === "webp" ? MAX_RESIZE_SIZE_FOR_WEBP_IN_PX : MAX_RESIZE_SIZE_IN_PX;
        if (!validateResizeDimension(image, dimensionType, unit, percentage, maxSize, dpi)) {
            isValid = false;
        }
    });

    return isValid;
};
